import axios from "axios";

export async function getLocaleMaps(address) {
  const apiMaps = axios.create({
    httpAgent: false,
    baseURL: `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=AIzaSyCLSP50BG6pM3YuGCAvCvQq39fXJ1xtggQ`,
  });
  
  try {
    const response = await apiMaps.get();
    return response.data;
  } catch (error) {
    throw error;
  }
}